import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Location\CreateLocationController::__invoke
* @see app/Http/Controllers/Location/CreateLocationController.php
* @route '/api/location'
*/
const CreateLocationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateLocationController.url(options),
    method: 'post',
})

CreateLocationController.definition = {
    methods: ["post"],
    url: '/api/location',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Location\CreateLocationController::__invoke
* @see app/Http/Controllers/Location/CreateLocationController.php
* @route '/api/location'
*/
CreateLocationController.url = (options?: RouteQueryOptions) => {
    return CreateLocationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Location\CreateLocationController::__invoke
* @see app/Http/Controllers/Location/CreateLocationController.php
* @route '/api/location'
*/
CreateLocationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateLocationController.url(options),
    method: 'post',
})

export default CreateLocationController